import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  Input,
  OnDestroy,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core'
import { ClerkService } from '../services/clerk.service'
import { take } from 'rxjs'
import { SignInProps } from '@clerk/types'

@Component({
  selector: 'clerk-sign-in',
  imports: [],
  template: `<div #ref></div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ClerkSignInComponent implements AfterViewInit, OnDestroy {
  @ViewChild('ref') public ref: ElementRef | null = null

  @Input() public props: SignInProps | undefined

  private _clerk = inject(ClerkService)

  public ngAfterViewInit() {
    this._clerk.clerk$.pipe(take(1)).subscribe((clerk) => {
      clerk.mountSignIn(this.ref?.nativeElement, this.props)
    })
  }

  public ngOnDestroy() {
    this._clerk.clerk$.pipe(take(1)).subscribe((clerk) => {
      clerk.unmountSignIn(this.ref?.nativeElement)
    })
  }
}
